import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Paths, SidebarOptionType } from '@/types/routes';
import { getServiceById } from '@/services/serviceRegistry';
import { AppModules } from '@/types';

const featureCards: SidebarOptionType[] = (() => {
  const service = getServiceById(AppModules.TALENTX);
  return service?.sidebarMenus ?? [];
})();

const TalentXDashboardComponent = function (): JSX.Element {
  return (
    <Box sx={{ padding: '40px' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        TalentX
      </Typography>
      <Typography variant="body1" sx={{ color: '#6f7175', mb: 4 }}>
        Recruitment & hiring pipeline
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          gap: '16px',
        }}
      >
        {featureCards.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Box
                sx={{
                  p: 3,
                  borderRadius: '12px',
                  border: '1px solid #ebebeb',
                  backgroundColor: '#fff',
                  transition: 'box-shadow 0.2s, border-color 0.2s',
                  '&:hover': {
                    borderColor: '#f2a654',
                    boxShadow: '0 4px 16px rgba(242, 166, 84, 0.12)',
                  },
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                  <Icon sx={{ color: '#f2a654', fontSize: 24 }} />
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, opacity: 1, color: '#202123' }}>
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            </Link>
          );
        })}
      </Box>
    </Box>
  );
};

export default TalentXDashboardComponent;
